export default __webpack_public_path__ + "static/designer-8313f8e3c69a85f76c15e485eb849792.svg";